/**
 * This file establishes supported screen type names and parameters
 * The definitions and schemas should match what jobseeker screen apps expect to receive
 * The schemas are also prop types, so we should use the appropriate prop type for the associated screen type component
 */

import PropTypes from 'prop-types';

/**
 * First draft design spec for Apply Flow
 * Detailed documentation in this spreadsheet
 * https://docs.google.com/spreadsheets/d/1BN4asBa-Ag-JkJsuPA5e04_mVqSLJkUAF0LORJrRrV4/edit#gid=0
 */

export const contactPropTypes = PropTypes.shape({
  name: PropTypes.string,
  phone_number: PropTypes.string,
});

export enum ScreenType {
  COLLECT_NAME_AND_PHONE_NUMBER = 'collect_name_and_phone_number',
  UPLOAD_RESUME_OR_CREATE_PROFILE = 'upload_resume_or_create_profile',
  PARTNER_REQUIRED_FIELDS = 'partner_required_fields',
  EMPLOYER_SCREENING_QUESTIONS = 'interview',
  EMPLOYER_SCREENING_QUESTIONS_V2 = 'interview_v2',
  PLATFORM_SUGGESTIONS = 'platform_suggestions',
  KEY_PROFILE_FIELDS = 'key_profile_fields',
  MERGE_PARSED_RESUME = 'merge_parsed_resume',
  MERGE_PARSED_RESUME_APPROVAL = 'merge_parsed_resume_approval',
  ELIGIBILITY_CELEBRATION = 'eligibility_celebration',
  MOBILE_APP_NOTIFICATION_PROMO = 'ii_notification_promo',
  MOBILE_APP_PRODUCT_PROMO = 'ii_product_promo',
  SET_PASSWORD = 'set_password',
  FINALIZE_APPLY = 'finalize_apply',
  COLLECT_EMAIL_ADDRESS = 'collect_email_address',
  PERFORM_APPLY = 'perform_apply',
  WARNING_MODAL = 'exit_warning',
  EXISTING_EMAIL_ADDRESS_MODAL = 'existing_email_address',
}

export const {
  COLLECT_NAME_AND_PHONE_NUMBER,
  UPLOAD_RESUME_OR_CREATE_PROFILE,
  PARTNER_REQUIRED_FIELDS,
  EMPLOYER_SCREENING_QUESTIONS,
  EMPLOYER_SCREENING_QUESTIONS_V2,
  PLATFORM_SUGGESTIONS,
  KEY_PROFILE_FIELDS,
  MERGE_PARSED_RESUME,
  MERGE_PARSED_RESUME_APPROVAL,
  ELIGIBILITY_CELEBRATION,
  MOBILE_APP_PRODUCT_PROMO,
  MOBILE_APP_NOTIFICATION_PROMO,
  SET_PASSWORD,
  FINALIZE_APPLY,
  COLLECT_EMAIL_ADDRESS,
  PERFORM_APPLY,
  WARNING_MODAL,
  EXISTING_EMAIL_ADDRESS_MODAL,
} = ScreenType;

export const collectNameAndPhoneNumberPropTypes = PropTypes.shape({
  name: PropTypes.string,
  phone_number: PropTypes.string,
});

export const uploadResumeOrCreateProfilePropTypes = PropTypes.shape({
  name: PropTypes.string,
  phone_number: PropTypes.string,
  profile_has_job_history: PropTypes.bool,
  profile_has_school_history: PropTypes.bool,
  ual_data: PropTypes.shape({}),
});

export const partnerRequiredFieldsPropTypes = PropTypes.shape({
  location_autocomplete_url: PropTypes.string.isRequired,
  // a bit gross, but the API returns the search param value as is, which is "1" if it's there
  partner_req_fields_submitted: PropTypes.string,
  profile_city: PropTypes.string,
  profile_state: PropTypes.string,
  profile_country: PropTypes.string,
  profile_zipcode: PropTypes.string,
});

export const employerScreeningQuestionsPropTypes = PropTypes.shape({
  enc_response_id: PropTypes.string.isRequired,
});

export const platformSuggestionsPropTypes = PropTypes.shape({
  enc_quiz_id: PropTypes.string.isRequired,
  ip_country_code: PropTypes.string,
  location_autocomplete_url: PropTypes.string.isRequired,
  num_suggestions_complete: PropTypes.number.isRequired,
  response_id: PropTypes.number.isRequired,
  skill_limit: PropTypes.number.isRequired,
  suggestions: PropTypes.arrayOf(PropTypes.shape({
    optional: PropTypes.number.isRequired,
    reply_params: PropTypes.arrayOf(PropTypes.shape({})),
    suggestion_key: PropTypes.string.isRequired,
    title: PropTypes.string,
  })).isRequired,
  total_screening_questions: PropTypes.number.isRequired,
});

export const keyProfileFieldsPropTypes = PropTypes.shape({
  ip_country_code: PropTypes.string.isRequired,
  location_autocomplete_url: PropTypes.string.isRequired,
});

export const mergeParsedResumePropTypes = PropTypes.shape({});

export const mergeParsedResumeApprovalPropTypes = PropTypes.shape({});

export const eligibilityCelebrationPropTypes = PropTypes.shape({});

export const mobileAppPromoPropTypes = PropTypes.shape({});

export const setPasswordPropTypes = PropTypes.shape({});
